import {contactFormApi} from "./contact_form_api";

export interface IContactFormInquiryPayload {
    email: string;
    phone: string;
    first_name: string;
    last_name: string;
    message: string;
    bigdata_marketing_consent?: boolean;
}

export const add_contact_form_inquiry = contactFormApi.injectEndpoints({
    endpoints: (build) => ({
        contactFormInquiry: build.mutation<IContactFormInquiryPayload, IContactFormInquiryPayload>({
            query: (payload) => ({
                url: `/`,
                method: "POST",
                body: payload
            })
        })
    }),
    overrideExisting: false
});

export const {useContactFormInquiryMutation} = add_contact_form_inquiry;
